import React from 'react';
import cx from 'classnames';

import FeaturedBaseView from './FeaturedBaseView';

const FeaturedH1View = (props) => {
  return (
    <FeaturedBaseView
      {...props}
      HeadingTag="h1"
      headerSize="big"
      className={cx('featured-h1', props.className)}
      buttons="true"
    />
  );
};

export default FeaturedH1View;
